import { Injectable }                      from '@angular/core';
import { ModalDismissReasons, NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { VehicleVisualsPlayerComponent } from './vehicle-visuals.player.component';

@Injectable({
  providedIn: 'root'
})
export class VehicleVisualsService {
  constructor (
    private modalService: NgbModal
  ) {}

  play ( url : string, title? : string ) : Promise<any> {
    const playUrl  = this.withAutoPlay(url);
    const modalRef = this.modalService.open(VehicleVisualsPlayerComponent, {
      windowClass: this.modalWindowClass()
    });

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.url   = playUrl;

    return modalRef.result.catch(( reason : any ) => {
      if (this.isDismiss(reason)) {
        return null;
      }

      return Promise.reject(reason);
    });
  }

  /**
   * Inspection-bundle customers see attachments from a short-URL vendor share
   * page whose chrome dwarfs the player at our default modal size. Render the
   * modal full-screen on that bundle so the player fills the viewport.
   */
  private modalWindowClass () : string {
    const base = 'vehicle-visuals-player-modal';

    return window.location.pathname.includes('inspection.html')
      ? `${ base } vehicle-visuals-player-modal-fullscreen`
      : base;
  }

  private withAutoPlay ( url : string ) : string {
    return url.replace(/auto_play=\d+/, 'auto_play=1');
  }

  private isDismiss ( reason : any ) : boolean {
    return reason === undefined
      || reason === ModalDismissReasons.BACKDROP_CLICK
      || reason === ModalDismissReasons.ESC;
  }
}
